/* eslint-disable import/newline-after-import */
import Alt from 'alt';
export default new Alt();
